import {
  generateExportDataFromBomData,
  generateExportDataFromListItems,
  generateFullBom,
  InflatedProductBom, PackQuantityProvider,
  PricingParams,
} from '../bom/bomUtils'
import { DownloadListFormats } from '../list/DownloadListPopup'
import { InflatedListItemProduct } from '../list/ListTypes'
import downloadCsv from './downloadCsv'

export const onDownloadList = (listProducts: readonly InflatedListItemProduct[], packQuantityProvider: PackQuantityProvider, pricing: PricingParams | null, formatType?: DownloadListFormats) => {
  downloadCsv('Iconic Export.csv', generateExportDataFromListItems(listProducts, packQuantityProvider, pricing))
}

export const onDownloadBom = (listProducts: readonly Readonly<InflatedProductBom>[], packQuantityProvider: PackQuantityProvider, pricing: PricingParams | null, formatType?: DownloadListFormats) => {
  downloadCsv('Iconic Export.csv', generateExportDataFromBomData(generateFullBom(listProducts, packQuantityProvider), pricing))
}